import request from '../index'
import Qs from 'qs'

/**
 * 获取商品列表
 * @param {*} query
 * @returns
 */
export function getGameGoods(query) {
    return request({
        url: '/box/goods/list',
        method: 'get',
        params: query
    })
}

/**
 * 获取商品规格详情
 * @param {*} query
 * @returns
 */
export function getGoodsSp(query) {
    return request({
        url: '/box/goods/specificationList',
        method: 'get',
        params: query
    })
}

/**
 * 获取商品详情
 * @param {*} query
 * @returns
 */
export function getGoodsDetail(query) {
    return request({
        url: '/box/goods/detail',
        method: 'get',
        params: query
    })
}

/**
 * 获取任务列表
 * @param {*} query
 * @returns
 */
export function getTaskList(query) {
    return request({
        url: '/box/taskList',
        method: 'get',
        params: query
    })
}

/**
 * 获取任务账号
 * @param {*} query
 * @returns
 */
export function getTaskAccount(query) {
    return request({
        url: '/box/account/getAccountByTaskId',
        method: 'get',
        params: query
    })
}

/**
 * 完成任务
 * @param {*} data
 * @returns
 */
export function finishTask(data) {
    return request({
        url: '/box/task/finish',
        method: 'post',
        data
    })
}

/**
 * 获取邮箱验证链接
 * @param {*} query
 * @returns
 */
export function verifyEmailUrl(query) {
    return request({
        url: '/box/steam/accountVerify',
        method: 'get',
        params: query,
        'axios-retry': {
            retries: 0
        }
    })
}

/**
 * 领取任务日志
 * @param {*} data
 * @returns
 */
export function getTaskLog(data) {
    return request({
        url: '/box/task/logList',
        method: 'post',
        data: Qs.stringify(data),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

/**
 * 获取商品绑定的规格详情
 * @param {*} query
 * @returns
 */
export function getSpInfo(query) {
    return request({
        url: '/shops/goods/specificationListBySids',
        params: query
    })
}

/**
 * 获取推荐商品列表
 * @param {*} params
 * @returns
 */
export function getRecGoods(params) {
    return request({
        url: '/box/BoxGoodsRecommend/list',
        params
    })
}

/**
 * 获取游戏列表
 * @param {*} params
 * @returns
 */
export function getGameList(params) {
    return request({
        url: '/game/info/list',
        params
    })
}

/**
 * 获取mod类型列表
 * @param {*} params
 * @returns
 */
export function getBoxModTypeList(params) {
    return request({
        url: '/box/BoxModType/list',
        params
    })
}

/**
 * mod下载量更新
 * @param {*} params
 * @returns
 */
export function modDownloadNum(id) {
    return request({
        url: '/box/BoxMod/downloadnum',
        params: { id }
    })
}


/**
 * 获取mod列表（集合了mod和mod前置）
*/
export function getGameModList(params) {
    return request({
        url: '/box/BoxModUnionPre/list',
        params
    })
}

/**
 * 获取Mod列表
 * @param {*} params
 * @returns
 */
export function getBoxModList(params) {
    return request({
        url: '/box/BoxMod/list',
        params
    })
}

/**
 * 获取mod详情
 * @param {*} params
 * @returns
 */
export function getModDetail(params) {
    return request({
        url: '/box/BoxMod/detail',
        method: 'get',
        params
    })
}

/**
 * 获取Mod前置列表
 * @param {*} params
 * @returns
 */
export function getBoxPreModList(params) {
    return request({
        url: '/box/BoxModPre/list',
        params
    })
}

/**
 * 获取mod前置详情
 * @param {*} params
 * @returns
 */
export function getModPreDetail(params) {
    return request({
        url: '/box/BoxModPre/detail',
        method: 'get',
        params
    })
}

/**
 * 获取商城的商品详情
 * @param {*} params
 * @returns
 */
export function getShopsGoodsDetail(params) {
    return request({
        url: '/shops/custom/goodsDetail',
        params
    })
}

/**
 * 获取游戏详情页推荐商品
 * @param {*} params
 * @returns
 */
export function getDetailRecGoods(params) {
    return request({
        url: '/box/BoxBindShopgoods/detail',
        method: 'get',
        params
    })
}
